

















import { Vue, Component, Watch } from 'vue-property-decorator';
import SearchBar from '../components/SearchBar.vue';
import VoteList from '../components/VoteList.vue';
@Component({
  components: {
    SearchBar,
    VoteList,
  },
})
export default class List extends Vue {
  activeType = '1';
  searchText = '请输入作者或作品名称';
  tab = [
    { text: '海报', id: '1' },
    { text: '宣传标语', id: '2' },
    { text: '创意文案', id: '3' },
  ];
  id: number = 1;
  mounted() {
    const type = this.$route.query.type;
    const scrolltop = this.$route.query.scrollTop;
    if (type === '海报类') {
      this.activeType = '1';
    } else if (type === '宣传标语类') {
      this.activeType = '2';
    } else if (type === '创意文案类') {
      this.activeType = '3';
    }
    this.id = parseInt(this.activeType);
    window.scrollTo(0, parseInt(scrolltop + ''));
  }
  changeTab(item: any) {
    this.id = parseInt(item.id);
    this.activeType = item.id;
  }
  // @Watch('id')
  // handleId(newval: any, oldval: any) {
  //   if (newval !== oldval) {
  //     this.id = newval;
  //   }
  // }
}
